import Vue from 'vue'

const app = {
	state: {
		isVerticalScreen: false,
		scaleRate: 1
	},
	mutations: {
		SET_VERTICAL_SCREEN: (state, val) => {
			state.isVerticalScreen = val;
		},
		SET_SCALE_RATE: (state, val) => {
			state.scaleRate = val;
		}
	},
	actions: {
		setVerticalScreen: ({
			commit
		}, val) => {
			commit('SET_VERTICAL_SCREEN', val)
		},
		setScaleRate: ({
			commit
		}, val) => {
			commit('SET_SCALE_RATE', val)
		},
	}
}
export default app